interface LinkProps {
  children: React.ReactNode;
  value?: any; // Property 'value' is optional in type 'PortableTextMarkComponentProps<any>'
}

interface LinkValue {
  href: string;
  targetBlank?: boolean;
  rel?: string;
  ariaLabel?: string;
}

const Link: React.FC<LinkProps> = ({ value, children }) => {
  const { href, targetBlank, rel, ariaLabel } = value as LinkValue;

  const ariaLabelNewTab =
    typeof children === 'string'
      ? `${ariaLabel || children} (Open in a new tab)`
      : `${ariaLabel || ''} (Open in a new tab)`;

  return (
    <>
      {targetBlank ? (
        // eslint-disable-next-line react/jsx-no-target-blank
        <a
          href={href}
          target={targetBlank && '_blank'}
          rel={rel && rel}
          aria-label={ariaLabelNewTab}>
          {children}
        </a>
      ) : (
        <a href={href} rel={rel && rel} aria-label={ariaLabel}>
          {children}
        </a>
      )}
    </>
  );
};

export default Link;
